<template>
  <div class="mb-4 pb-1 border-bottom">
    <h5 class="text-dark fw-bold">
      {{ $t('master.user.userInformation.title') }}
    </h5>
    <p class="text-muted mb-3">
      {{ $t('master.user.userInformation.description') }}
    </p>

    <!-- User Type Radio - hanya tampil saat create -->
    <div class="mb-3">
      <label class="form-label">{{ $t('master.user.userType') }}</label>
      <b-form-group>
        <b-form-radio
          v-model="localForm.isEmployee"
          plain
          disabled
          value="true"
          inline
          class="me-4"
        >
          {{ $t('master.karyawan') }}
        </b-form-radio>
        <b-form-radio v-model="localForm.isDriver" plain disabled value="true" inline>
          {{ $t('master.driver') }}
        </b-form-radio>
      </b-form-group>
    </div>

    <!-- Name Selection -->
    <div class="mb-3">
      <label class="form-label">{{ $t('master.user.name') }}</label>
      <multiselect
        :value="form"
        :options="nameOptions"
        :placeholder="$t('master.user.selectName')"
        label="fullname"
        class="mc-user-modal__multiselect"
        :class="{
          'is-invalid': $v.form.fullname.$error,
        }"
        group-values="users"
        group-label="department"
        :group-select="false"
        disabled
      />
      <div v-if="!$v.form.fullname.$error" class="custom-input-help-text input-md">
        <label class="custom-required-help-text">
          <span>* </span>{{ $t('global.validation.required') }}
        </label>
      </div>
      <div v-if="$v.form.fullname.$error" class="invalid-feedback">
        <span v-if="!$v.form.fullname.required">
          {{ $t('master.user.name') }} {{ $t('global.validation.required') }}
        </span>
      </div>
    </div>

    <!-- Group Selection -->
    <div class="mb-3">
      <label class="form-label">{{ $t('master.user.group') }}</label>
      <multiselect
        ref="groupOptions"
        v-model="localForm.groups"
        :options="ugroups.ugroups"
        :placeholder="`${$t('global.form.select')} ${$t('master.user.group')}`"
        label="name"
        track-by="name"
        :class="{
          'is-invalid': $v.form.groups.$error,
        }"
        autocomplete="off"
        :disabled="disabledTmsUserGroupAccess"
        @input="(val) => $emit('change-group', val)"
      />
      <div v-if="!$v.form.groups.$error" class="custom-input-help-text input-md">
        <label class="custom-required-help-text">
          <span>* </span>{{ $t('global.validation.required') }}
        </label>
      </div>
      <div v-if="$v.form.groups.$error" class="invalid-feedback">
        <span v-if="!$v.form.groups.required">
          {{ $t('master.user.group') }} {{ $t('global.validation.required') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { required, email, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'

// Custom phone number validator
const phoneNumber = (value) => {
  if (!value) return true

  const cleanPhone = value.replace(/\D/g, '')

  // Pola:
  // 1. Boleh diawali 0 lalu diikuti [1-9]...
  // 2. Atau diawali kode negara (1–3 digit) tapi setelahnya tidak boleh '0'
  const pattern = /^(0[1-9]\d{7,11}|[1-9]\d{0,2}[1-9]\d{6,10})$/

  return pattern.test(cleanPhone)
}

export default {
  name: 'UserInformationSection',

  components: {
    Multiselect,
  },

  mixins: [Helper],

  props: {
    form: {
      type: Object,
      required: true,
    },

    nameOptions: {
      type: Array,
      default: () => [],
    },

    ugroups: {
      type: Object,
      default: () => ({}),
    },
  },

  validations: {
    form: {
      fullname: { required },
      groups: { required },
    },
  },
  data() {
    return {
      localForm: { ...this.form },
    }
  },

  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    disabledTmsUserGroupAccess() {
      if (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ])
      ) {
        if (this.isSuperUser()) {
          return false
        }
        return true
      }

      return this.form?.groups?.mgroupId == 0
    },
  },
}
</script>
